const desktopHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
let activeContainer = null;

function getZoomContainer(target) {
  if (!desktopHoverQuery.matches || !(target instanceof Element)) return null;

  return target.closest(
    'media-gallery .product-media-container--image.product-media-container--zoomable:not(.dialog-zoomed-gallery *)'
  );
}

function getZoomImage(container) {
  return container?.querySelector('.product-media__image');
}

function setZoomOrigin(event, image) {
  const bounds = image.getBoundingClientRect();
  const x = ((event.clientX - bounds.left) / bounds.width) * 100;
  const y = ((event.clientY - bounds.top) / bounds.height) * 100;

  image.style.setProperty('--franklen-hover-zoom-x', `${Math.max(0, Math.min(100, x))}%`);
  image.style.setProperty('--franklen-hover-zoom-y', `${Math.max(0, Math.min(100, y))}%`);
}

function clearActiveZoom() {
  if (!activeContainer) return;

  const image = getZoomImage(activeContainer);
  image?.classList.remove('franklen-hover-zoom__image--active');
  activeContainer.classList.remove('franklen-hover-zoom--active');
  activeContainer = null;
}

document.addEventListener(
  'pointermove',
  (event) => {
    const container = getZoomContainer(event.target);

    if (!container) {
      clearActiveZoom();
      return;
    }

    const image = getZoomImage(container);
    if (!image) return;

    activeContainer = container;
    setZoomOrigin(event, image);
    container.classList.add('franklen-hover-zoom--active');
    image.classList.add('franklen-hover-zoom__image--active');
  },
  { passive: true }
);

document.addEventListener('pointerleave', clearActiveZoom, true);
document.addEventListener('scroll', clearActiveZoom, { passive: true });

// Desktop PDP images use hover zoom instead of Horizon's click-to-lightbox trigger.
// Touch/mobile users keep the theme's native tap/click zoom behavior.
document.addEventListener(
  'click',
  (event) => {
    const container = getZoomContainer(event.target);

    if (!container) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

desktopHoverQuery.addEventListener('change', clearActiveZoom);
